import { Session } from '@ais-ui/auth';

export const acknowledgeEvent = async (session: Session, eventId: string) => {
  const response = await session.request('ackEdEvent', { eventId });

  return response;
};
